import { cloneElement, isValidElement, ReactElement, Children } from 'react';
import { ListBodyProps } from '../../types';

export function ListBody({
  children,
  ...rest
}: Partial<ListBodyProps>): ReactElement | null {
  if (!children || !isValidElement(children)) {
    return null;
  }

  if (!Children.only(children)) {
    throw new Error('ListBody must have only one child');
  }

  return cloneElement(children as ReactElement, rest);
}
